import { SSO_CALLBACK_PATH } from "../../app/modules/Login/SSOCallback";

export const PUBLIC_ROUTE_PATHS = [
  "/",
  "/login",
  SSO_CALLBACK_PATH,
  "/notice",
  "/register",
  "/signup",
  "/otp",
  "/create-password",
  "/succcreateess",
  "/forgot-password",
  "/change-password",
  "/unauthorized",
] as const;

export function isPublicRoute(pathname: string): boolean {
  if (PUBLIC_ROUTE_PATHS.includes(pathname as (typeof PUBLIC_ROUTE_PATHS)[number])) {
    return true;
  }

  return /^\/payments\/process\/[^/]+\/[^/]+$/.test(pathname);
}
